export default __webpack_public_path__ + "static/media/blank.07c1da88.svg";